import {
  BUSINESS_TASK_PASS_REWARD,
  NOTIFICATIONS_PASS_REWARD,
  PASSES_CAP,
} from './constants';
import type { PlayerEconomyState } from './types';

export type VkBusinessTaskClaimResult = {
  alreadyClaimed: boolean;
  state: PlayerEconomyState;
  rewardPasses: number;
};

export function isNotificationsRewardClaimed(state: PlayerEconomyState): boolean {
  return state.notificationsRewardClaimed === true;
}

export function isVkSubscribeRewardClaimed(state: PlayerEconomyState): boolean {
  return state.vkSubscribeRewardClaimed === true;
}

export function claimNotificationsReward(state: PlayerEconomyState): VkBusinessTaskClaimResult {
  if (isNotificationsRewardClaimed(state)) {
    return { alreadyClaimed: true, state, rewardPasses: 0 };
  }
  const rewardPasses = NOTIFICATIONS_PASS_REWARD;
  return {
    alreadyClaimed: false,
    rewardPasses,
    state: {
      ...state,
      notificationsRewardClaimed: true,
      passesBalance: Math.min(PASSES_CAP, state.passesBalance + rewardPasses),
    },
  };
}

export function claimVkSubscribeReward(state: PlayerEconomyState): VkBusinessTaskClaimResult {
  if (isVkSubscribeRewardClaimed(state)) {
    return { alreadyClaimed: true, state, rewardPasses: 0 };
  }
  const rewardPasses = BUSINESS_TASK_PASS_REWARD;
  return {
    alreadyClaimed: false,
    rewardPasses,
    state: {
      ...state,
      vkSubscribeRewardClaimed: true,
      passesBalance: Math.min(PASSES_CAP, state.passesBalance + rewardPasses),
    },
  };
}
